import { debug } from '../utils'
import { generateVisitorId, setVisitorIdCookie, getVisitorIdCookie } from '../visitorIdUtils'

const cleanObject = (obj, test = (v) => !v) => {
  Object.keys(obj).forEach((key) => {
    if (test(obj[key])) delete obj[key]
  })

  return obj
}

const isEmpty = (o) => {
  return !o || !o.filters || (!o.query && !Object.keys(o.filters).length && !o.path?.length)
}

const equalObjects = (o1, o2) => {
  return JSON.stringify(o1) === JSON.stringify(o2)
}

export default {
  popping: false,
  setItem(key, json) {
    if (!this.popping) {
      const state = JSON.parse(json)
      cleanObject(state.filters, (v) => !v.length)

      if (!equalObjects(state, history.state) && (!isEmpty(state) || !isEmpty(history.state))) {
        const params = new URLSearchParams(
          cleanObject({
            query: state.query,
            path: state.path?.join('/'),
            seller: state.filters['attributes.seller']?.join('|'),
            brands: state.filters['brands']?.join('|'),
            utm_campaign: state.utm_campaign,
            utm_medium: state.utm_medium,
            utm_source: state.utm_source,
            ref_wk: state.ref_wk,
          })
        ).toString()

        const root = import.meta.env.VITE_HISTORY_ROOT.replace('/BHS_en/', `/${state.gateway}_${state.locale}/`)
        const url = root + (params ? `?${params}` : '')

        debug('Saving state', {
          old: history.state,
          new: state,
          params,
          url,
        })

        history.pushState(state, null, url)
      }
    }
  },
  getItem() {
    const state = history.state || { filters: {} }

    const urlParams = Object.fromEntries(new URLSearchParams(decodeURI(window.location.search)).entries())

    const existingVisitorId = getVisitorIdCookie()

    if (!existingVisitorId) {
      const visitorId = generateVisitorId()
      setVisitorIdCookie(visitorId, 365)
    }

    if (existingVisitorId) {
      state.visitorId = existingVisitorId
    }

    if (urlParams.query) {
      state.query = urlParams.query
    }

    if (urlParams.path) {
      state.path = urlParams.path.split('/')
    }

    if (urlParams.seller) {
      state.filters['attributes.seller'] = urlParams.seller.split('|')
    }

    if (urlParams.brands) {
      state.filters['brands'] = urlParams.brands.split('|')
    }

    debug('Restoring state', state)
    return JSON.stringify(state)
  },
}
